import createRoute            from '@widesk-ui/tools/createRoute';
import TimedNotificationModel from '@models/website/TimedNotificationModel';

const route = createRoute.splitView(
	'/website_entertainments/:websiteEntertainmentId/timed_notifications',
	'website',
	'TimedNotificationSplitView',
	TimedNotificationModel.localize('plural'),
);
export default route;
